import actions from './actions'

export default function ContractInvoicePartnerPersonsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTINVOICEPARTNERPERSON:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTINVOICEPARTNERPERSON:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTINVOICEPARTNERPERSON:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTINVOICEPARTNERPERSON:
      return {
        ...state,
        editing: { contractInvoicePartnerPersonID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CONTRACTINVOICEPARTNERPERSON_RECIEVED:
    case actions.DELETE_CONTRACTINVOICEPARTNERPERSON_RECIEVED:
      return {
        ...state,
        editing: { contractInvoicePartnerPersonID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
